import { Label } from "./ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select"


interface NumberFormatSelectorProps {
  unit: string
  setUnit: (unit: string) => void
}

const NumberFormatSelector = ({ unit, setUnit }: NumberFormatSelectorProps) => {
  return (
    <div className="flex flex-col gap-1 items-start">
      <Label htmlFor="">ຫົວໜ່ວຍເງິນ (ກີບ)</Label>
      <Select
        onValueChange={(value) => setUnit(value)}
        defaultValue={unit || "1"}
        value={unit || "1"}
      >
        <SelectTrigger className="w-[120px] indent-1	">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="1">1</SelectItem>
          <SelectItem value="10">10</SelectItem>
          <SelectItem value="100">100</SelectItem>
          <SelectItem value="1000">1,000</SelectItem>
          <SelectItem value="10000">10,000</SelectItem>
          <SelectItem value="100000">100,000</SelectItem>
          <SelectItem value="1000000">1,000,000</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}

export default NumberFormatSelector